import React from "react";
import { Col, Form, Row } from "reactstrap";
import { Link } from "react-router-dom";
import Config from "../../utils/config";
import InputText from "../InputText";
import { ic_email } from "react-icons-kit/md/ic_email";
import Icon from "react-icons-kit";
import CustomBtn from "../CustomButton";
import "../../assets/css/components/login.css";
import Loader from "../Loader";

import get from "lodash/get";

const _ = { get };
export default class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNo: "",
    };
  }

  handleChange = (e) => {
    e.preventDefault();
    let state = this.state;
    state[e.target.name] = e.target.value.trim();
    this.setState({ ...state });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let state = this.state;
    this.props.handleForgotPassword(state.mobileNo);
  };

  render() {
    let { elements } = this.props;
    return (
      <Row className=" no-gutters h-100">
        {this.props.forgetPasswordStatus !== false ? <Loader /> : null}
        <Col
          sm="12"
          md="12"
          lg="12"
          xl="6"
          className="user-auth-wrapper h-100"
          style={{
            backgroundImage: `url(${Config.imageBaseUrl}/EU0001/node/assets/dashboard/riders-portal/login-banner.webp)`,
          }}
        ></Col>
        <Col sm="12" md="12" lg="12" xl="6" className="h-100 login-wrapper">
          <div className="light-overlay">
            <div className="user-auth-container">
              <div className="logo">
                <img
                  src={`${Config.imageBaseUrl}/content/dam/re-platform-images/logo.svg`}
                  alt="banner"
                />
              </div>
              <div className="app-login-register-container">
                <Form onSubmit={this.handleSubmit} className="w-100">
                  <div className="p-2 p-lg-0">
                    <div className="position-relative mt-4">
                      <Icon
                        size={22}
                        className="inputIcon LeftIcon"
                        icon={ic_email}
                      />
                      <InputText
                        inputType={"text"}
                        inputName={"mobileNo"}
                        InputClass={"mt-3 mt-lg-5 mb-4 inputText"}
                        inputPlaceholder={_.get(
                          elements,
                          "forgotPasswordElement.emailPlaceholder",
                          "Email / Mobile"
                        )}
                        customOnChange={(e) => this.handleChange(e)}
                      />
                    </div>
                    <div className="bottom-sec">
                      <div className="d-flex align-items-center justify-content-center flex-column position-relative">
                        <CustomBtn
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "forgotPasswordElement.sendOTPButtonElement",
                            "Send OTP"
                          )}
                          customClass={"btn-outline-dark mb-4 btnthemeColor"}
                          iconSize={30}
                        />
                        <Link to="/auth/login" className="link">
                          <span className="bg-white position-relative px-2">
                            {_.get(
                              elements,
                              "forgotPasswordElement.backButtonElement",
                              "Back"
                            )}
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}
